"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRID = void 0;
const errors_1 = require("./errors");
const ridParser_1 = require("./parser/ridParser");
/**
 * Parses RID to leaf, segments, system, and root components.
 *
 * @param rid A RID string
 * @returns A parsed {@link RID} object
 * @throws A {@link RIDUtilsError} of type
 * Example:
 * ```md
 * Input: "sharefile:account-123/someresource-456/template-789/"
 *         ^-------^ ^-------^   ^-------------^  ^----------^
 *          system     root      segment 1         segment 2 (leaf)
 *         ^------------------------------------^
 *                      container
 * ```
 * Output:
 * ```TS
 * {
 *    leaf: { name: 'template', id: '789' },
 *    container: 'sharefile:account-123/someresource-456',
 *    root: { name: 'account', id: '123' },
 *    segments: [
 *      { name: 'account', id: '123' }, // root === segment 0
 *      { name: 'someresource', id: '456' },
 *      { name: 'template', id: '789' }
 *    ],
 *    system: 'sharefile'
 * }
 * ```
 */
const parseRID = (rid) => {
    try {
        return (0, ridParser_1.parse)(rid);
    }
    catch (error) {
        throw new errors_1.ParseError({ parentError: error });
    }
};
exports.parseRID = parseRID;
//# sourceMappingURL=parse.js.map